import { useEffect, useRef, useState } from "react"
import ArrowUpRightMosaic from "../../assets/mosaics/ArrowUpRightMosaic"
import BigLineMosaic from "../../assets/mosaics/BigLineMosaic"
import EyeMosaic from "../../assets/mosaics/EyeMosaic"
import HalfCircleMosaic from "../../assets/mosaics/HalfCircleMosaic"
import HalfTriangleMosaic from "../../assets/mosaics/HalfTriangleMosaic"
import LineMosaic from "../../assets/mosaics/LineMosaic"
import OvalMosaic from "../../assets/mosaics/OvalMosaic"
import QuarterCircleMosaic from "../../assets/mosaics/QuarterCircleMosaic"
import SquareMosaic from "../../assets/mosaics/SquareMosaic"
import StarMosaic from "../../assets/mosaics/StarMosaic"
import TargetMosaic from "../../assets/mosaics/TargetMosaic"
import TriangleMosaic from "../../assets/mosaics/TriangleMosaic"
import { useGSAP } from "@gsap/react"
import gsap from "gsap"
import clsx from "clsx"
import { useMediaQuery } from "react-responsive"

const allMosaics = [
    <SquareMosaic />,
    <TargetMosaic />,
    <TriangleMosaic />,
    <QuarterCircleMosaic />,
    <OvalMosaic />,
    <HalfTriangleMosaic />,
    <HalfCircleMosaic />,
    <ArrowUpRightMosaic />,
    <StarMosaic />,
    <BigLineMosaic />,
    <EyeMosaic />,
    <LineMosaic />
]

function MosaicLineGrid({
    number = null
}) {
    const isMobile = useMediaQuery({
        query: "(max-width: 780px)"
    })

    function getMosaics(){
        if(number){
            return allMosaics.slice(0,number);
        }
        return isMobile ? allMosaics.slice(0,4) : allMosaics;
    }
    
    const mosaics = getMosaics();

    return (
        <div className={clsx(
            "grid",
        )}
        style={
            {
                gridTemplateColumns: `repeat(${mosaics.length},1fr)`
            }
        }>
            {mosaics.map(mosaic =>
                <div className="aspect-square">
                    {mosaic}
                </div>
            )}
        </div>
    )
}
export default function MosaicsLine({
    reversed = false,
    number = null
}) {
    const slideRef = useRef(null);

    useGSAP(()=>{
        gsap.to(slideRef.current,{
            ease: "linear",
            xPercent: -100,
            duration: 20,
            repeat: -1
        })
    },[]);
    return (
        <div className={clsx(
            "w-full overflow-hidden",
            reversed && "-scale-x-100"
        )}>
            <div className="flex" ref={slideRef}>
                <div className="min-w-full">
                    <MosaicLineGrid number={number}/>
                </div>
                <div className="min-w-full">
                    <MosaicLineGrid number={number}/>
                </div>
            </div>
        </div>
    )
}